import React from 'react';

const NotFound = () => {
    return (
        <div className='py-5 text-center d mt-10'>
            <h2>404 - Page Not Found</h2>
            <p>Sorry, the page you're looking for doesn't exist.</p>

        </div>
    );
};
export default NotFound;
